import { Text } from "react-native";
import { RepositColours } from "../utils/styles";
import React from "react";

const Phone = ({ children }) => {
  return (
    <Text style={{ color: RepositColours.blue }} onPress={() => {}}>
      <a href="tel:0282946545" style={{ color: RepositColours.blue }}>
        {children} (02)8294-6545
      </a>
    </Text>
  );
};

export default Phone;



// WEBPACK FOOTER //
// ./src/utils/Phone.web.js